
export enum RequestedChangeCd {
	BUSINESS_NAME_ALIAS = 'BusinessNameAlias',
	CONTACT = 'Contact',
	INVOICING = 'Invoicing',
	LOCATION = 'Location'}

